// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/autoplay";
// import "swiper/css/pagination";
// import "swiper/css/virtual";
// import "swiper/css/scrollbar";
// import "swiper/css/effect-fade";

// import {
//   Navigation,
//   Pagination,
//   Autoplay,
//   Virtual,
//   A11y,
//   EffectFade,
// } from "swiper/modules";

// import { Box, Grid, Button } from "@mui/material";
// import SendIcon from "@mui/icons-material/Send";
// import _ from "lodash";

// function BannerCarousel({ bgImage }) {
//   // Read from localStorage
//   const localImages = localStorage.getItem("websiteDetails");
//   const parseData = localImages ? JSON.parse(localImages) : null;

//   const images = parseData?.banner || [];

//   // slides MUST always be an array
//   const slides =
//     images.length > 0 ? images : Array.isArray(bgImage) ? bgImage : [bgImage];

//   return (
//     <>
//       <style>
//         {`
//         @media (max-width: 600px) {
//           .desktop-only { display: none !important; }
//           .mobile-only { display: block !important; }
//         }
//         @media (min-width: 601px) {
//           .desktop-only { display: block !important; }
//           .mobile-only { display: none !important; }
//         }
//       `}
//       </style>

//       {/* ----------------------- DESKTOP VERSION ----------------------- */}
//       <Box className="desktop-only">
//         <Swiper
//           style={{ width: "100%", height: "500px" }}
//           modules={[Navigation, Pagination, Autoplay, Virtual, A11y, EffectFade]}
//           effect="fade"
//           virtual
//           slidesPerView={1}
//           navigation
//           autoplay={{ delay: 3000 }}
//           loop
//           pagination={{ clickable: true }}
//         >
//           {slides.map((img, index) => (
//             <SwiperSlide key={index} virtualIndex={index}>
//               <Box
//                 sx={{
//                   width: "100%",
//                   height: "500px",
//                   backgroundImage: `url(${img})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                   position: "relative",
//                 }}
//               >
//                 {/* Content Box */}
//                 <Grid
//                   container
//                   sx={{
//                     position: "absolute",
//                     top: "20%",
//                     left: "7%",
//                     width: "60%",
//                   }}
//                 >
//                   <Grid
//                     item
//                     md={9}
//                     sm={12}
//                     xs={12}
//                     sx={{
//                       bgcolor: "#ffffff99",
//                       p: 3,
//                       borderRadius: "8px",
//                       backdropFilter: "blur(2px)",
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "center",
//                       alignItems: "flex-start",
//                       zIndex: 2,
//                     }}
//                   >
//                     <span className="title">
//                       Welcome to {_.get(parseData, "store_name", "Our Store")}!
//                     </span>

//                     <Button
//                       sx={{ mt: 2, width: "40%" }}
//                       variant="contained"
//                       endIcon={<SendIcon />}
//                     >
//                       Explore
//                     </Button>
//                   </Grid>
//                 </Grid>
//               </Box>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Box>

//       {/* ----------------------- MOBILE VERSION ----------------------- */}
//       <Box className="mobile-only">
//         <Swiper
//           style={{ width: "100%", height: "220px" }}
//           autoplay={{ delay: 3000 }}
//           loop
//         >
//           {slides.map((img, index) => (
//             <SwiperSlide key={index}>
//               <Box
//                 sx={{
//                   width: "100%",
//                   height: "220px",
//                   backgroundImage: `url(${img})`,
//                   backgroundSize: "cover",
//                   backgroundPosition: "center",
//                   position: "relative",
//                 }}
//               >
//                 <Grid
//                   item
//                   xs={12}
//                   sx={{
//                     height: "100%",
//                     display: "flex",
//                     alignItems: "center",
//                     p: 2,
//                   }}
//                 >
//                   <div
//                     style={{
//                       background: "rgba(0,0,0,0.5)",
//                       padding: "12px 16px",
//                       borderRadius: 8,
//                       color: "#fff",
//                     }}
//                   >
//                     <span style={{ fontSize: "1.2rem" }}>
//                       Welcome to {_.get(parseData, "store_name", "Our Store")}!
//                     </span>

//                     <Button
//                       sx={{ mt: 1 }}
//                       className="explore-btn"
//                       variant="contained"
//                       endIcon={<SendIcon />}
//                     >
//                       Explore
//                     </Button>
//                   </div>
//                 </Grid>
//               </Box>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Box>
//     </>
//   );
// }

// export default BannerCarousel;

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

import { Box, Grid, Button, Container } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import _ from "lodash";
import { useNavigate } from "react-router-dom";

const bgImage = require("../../assets/images/Webbie_default_banner.jpg");
function BannerCarousel({ type }) {
  // Read from localStorage
  const localData = localStorage.getItem("websiteDetails");
  const parseData = localData ? JSON.parse(localData) : null;
  const naviagte = useNavigate();
  // ONLY use localStorage banner images
  const slides =
    Array.isArray(parseData?.banner) && parseData?.banner?.length > 0
      ? parseData.banner
      : [bgImage];
  console.log("slides", slides, parseData?.banner);
  // // ONLY use localStorage banner images
  // const slides =Array.isArray(parseData?.banner)? parseData?.banner : []
  // type === "contact"
  //   ? parseData?.banner.slice(0,1)
  //   : type === "about"
  //   ? parseData?.banner.slice(0,1)
  // : parseData?.banner || [];
  return (
    <>
      {/* ----------------------- DESKTOP VERSION ----------------------- */}
      <Container maxWidth="lg" sx={{ px: { xs: 1.5, sm: 2 } }}>
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
            maxWidth: "1250px",
            width: "100%",
            margin: "0 auto",
            mt: { xs: "56px", sm: "90px", md: "90px" },
            borderRadius: "12px",
            overflow: "hidden",

            height: "clamp(200px, 25vw, 320px)",
            maxHeight: "320px",
          }}
        >
          <Swiper
            style={{ width: "100%", height: "100%" }}
            modules={[Autoplay]}
            slidesPerView={1}
            autoplay={{ delay: 3000 }}
            loop
          >
            {slides.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img}
                  alt="banner"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "fill", // ✅ NO STRETCH
                    objectPosition: "center",
                    display: "block",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Container>
      {/* ----------------------- MOBILE VERSION ----------------------- */}
      <Container
        maxWidth={false}
        sx={{
          px: { xs: 1.5, sm: 2 },
          display: { xs: "block", sm: "none" }, // ✅ only mobile
        }}
      >
        <Box
          sx={{
            width: "100%",
            margin: "0 auto",
            mt: "8rem",
            borderRadius: "12px",
            overflow: "hidden",
          }}
        >
          <Swiper
            modules={[Autoplay]}
            slidesPerView={1}
            navigation
            autoplay={{ delay: 3000 }}
            loop
          >
            {slides?.map((img, index) => (
              <SwiperSlide key={index}>
                <img
                  src={img}
                  alt="banner"
                  style={{
                    width: "100%",
                    height: "clamp(140px, 30vw, 200px)",

                    objectFit: "fill",
                    objectPosition: "center",
                    display: "block",
                  }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Container>
    </>
  );
}

export default BannerCarousel;
